import { CourrierLinked } from './courrier-linked';

export class CourriersLinkedToChemise {
  public courriers: CourrierLinked[];
  public description: string;
  public id: number;
}
